import PropTypes from 'prop-types';
import React, { useState } from 'react';
import SurveyIcon from '../SurveyIcon';
import { tcap } from '../../../utils/translate';

const EmbeddedSubmitButton = ({ id, isBusy }) => {
  
  const [displayBtn, setDisplayBtn] = useState(false);
  
  const handleIframeMessage = (event) => {
    if (event.data === 'surveyFinished') {
      setDisplayBtn(true)
    }
  };

  React.useEffect(() => {
    window.addEventListener('message', handleIframeMessage);

    // cleanup this component
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, []);

  return(
    <li className="srv-fin pos-r" style={{ height: '71px' }}>
      <button
        className={`btn btn-primary srv-fin-btn bc1 bg-${id} o-h m0 d-b pos-a rounded-bottom b0 fs-18 btn-ff-base`}
        disabled={isBusy}
        style={{
          width: '100%',
          left: '0',
          right: '0',
          top: '0',
          bottom: '0',
          padding: 0,
          lineHeight: '70px',
          display: displayBtn ? 'block' : 'none',
        }}
        type="submit"
      >
        {tcap('next')}
        <span
          className="anim zoomOut"
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            background: 'black',
            display: isBusy ? 'block' : 'none',
          }}
        >
          <SurveyIcon icon="ajax" style={{ verticalAlign: 'baseline' }} />{' '}
          sending...
        </span>
      </button>
    </li>
    )
  }

  EmbeddedSubmitButton.propTypes = {
  id: PropTypes.string.isRequired,
  isBusy: PropTypes.bool,
};

export default EmbeddedSubmitButton;
